import { render, staticRenderFns } from "./PopoverOrders.vue?vue&type=template&id=fe49fd70&scoped=true&"
import script from "./PopoverOrders.vue?vue&type=script&lang=js&"
export * from "./PopoverOrders.vue?vue&type=script&lang=js&"
import style0 from "./PopoverOrders.vue?vue&type=style&index=0&id=fe49fd70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe49fd70",
  null
  
)

export default component.exports